/**
 * ログイン状態のコンテキストと参照用のフック。
 *
 * ロールは認証基盤ではなくサーバー（利用者マスタ）が決める。画面はロールを表示制御にだけ使い、
 * 実際の権限判定はサーバーが毎回行う（docs/40_セキュリティ設計書.md §3）。
 */

import { createContext, useContext } from 'react';
import type { MeResponse } from '../api/types.js';
import type { AuthUser } from './identity.js';

export interface AuthState {
  loading: boolean;
  /** 認証基盤でのログイン状態 */
  account: AuthUser | null;
  /** 利用者マスタの情報。認証できてもマスタにいない場合は null */
  me: MeResponse | null;
  error: string | null;
  signInWithPassword(email: string, password: string): Promise<void>;
  signInWithGoogle(): Promise<void>;
  signOut(): Promise<void>;
  refresh(): Promise<void>;
}

export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const context = useContext(AuthContext);
  if (!context) throw new Error('AuthProvider の外側で useAuth は使えません');
  return context;
}

/** 利用者マスタの情報が必ずある画面で使う */
export function useMe(): MeResponse {
  const { me } = useAuth();
  if (!me) throw new Error('ログインしていません');
  return me;
}
